var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from 'react';
import { TableRow, TableData } from '../styles';
function PaddingRows(_a) {
    var count = _a.count, columns = _a.columns, rowActions = _a.rowActions;
    var finalColumns = [];
    if (rowActions) {
        finalColumns = __spreadArrays(columns, [{ label: '', render: function () { return ''; } }]);
    }
    return Array(count)
        .fill(0)
        .map(function (_, index) { return (React.createElement(TableRow, { key: "padding-row-" + index }, finalColumns.map(function (column) { return (React.createElement(TableData, { key: column.label }, "\u200B")); }))); });
}
export default PaddingRows;
